import {
  STORAGE_IS_FETCHING,
  STORAGE_IS_DELETEING,
  STORAGE_SUCCESS,
  STORAGE_UPDATE_CONTENT_TABLE,
  STORAGE_TABLE_ADD_ITEM,
  STORAGE_TABLE_DELETE_ITEM,
  STORAGE_FILTER,
  STORAGE_FILTER_CLEAR,
  STORAGE_FILTERS_ADD_TYPE,
  STORAGE_FILTERS_REMOVE_TYPE,
  STORAGE_UPDATE_TABLE
} from '../types'

const initialState = {
  isFetching: false,
  isDeleting: false,
  data: {
    files: []
  },
  table: {
    keys: [],
    rows: []
  },
  filters: {
    search: '',
    ext: [],
    matchAllTags: [],
    matchAnyTags: [],
    matchNoneTags: [],
    sort: 'DATE',
    order: 'DESC',

    page: 0,
    pageSize: 10
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case STORAGE_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload
      }

    case STORAGE_IS_DELETEING:
      return {
        ...state,
        isDeleting: action.payload
      }

    case STORAGE_SUCCESS:
      return {
        ...state,
        data: action.payload
      }

    case STORAGE_UPDATE_CONTENT_TABLE:
      return {
        ...state,
        table: action.payload
      }

    case STORAGE_TABLE_ADD_ITEM:
      return {
        ...state,
        table: {
          ...state.table,
          keys: [
            ...state.table.keys,
            action.payload.id
          ],
          rows: [
            ...state.table.rows,
            action.payload.item
          ]
        }
      }

    case STORAGE_TABLE_DELETE_ITEM:
      return {
        ...state,
        table: {
          keys: state.table.keys.filter(id => id !== action.payload.id),
          rows: state.table.rows.filter(row => row.id !== action.payload.id)
        }
      }

    case STORAGE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      }

    case STORAGE_FILTER_CLEAR:
      return {
        ...state,
        filters: initialState.filters
      }

    case STORAGE_FILTERS_ADD_TYPE:

      return {
        ...state,
        filters: {
          ...state.filters,
          ext: [...state.filters.ext, ...action.payload]
        }
      }

    case STORAGE_FILTERS_REMOVE_TYPE:

      let newTypeFilter = []

      state.filters.ext.forEach(item => {
        if (!action.payload.includes(item)) {
          newTypeFilter.push(item)
        }
      })

      return {
        ...state,
        filters: {
          ...state.filters,
          ext: newTypeFilter
        }
      }

    case STORAGE_UPDATE_TABLE:

      return {
        ...state,
        table: {
          ...state.table,
          rows: state.data.files.filter(file => state.table.keys.includes(file.id))
        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/storage.js